/**
 * Determine if the current hostname should render the public marketing site.
 * Production: np-productions.com → public, myevent.np-productions.com → app
 * Test: public-test.np-productions.com → public, test.np-productions.com → app
 * Local: localhost with ?public=true → public, otherwise → app
 */
export function isPublicSite(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  if (
    hostname === 'np-productions.com' ||
    hostname === 'www.np-productions.com' ||
    hostname === 'public-test.np-productions.com'
  ) {
    return true;
  }
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    const params = new URLSearchParams(window.location.search);
    return params.get('public') === 'true';
  }
  return false;
}
